/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import SGColumnHeader from '@usas/ui-web/components/grids/SGColumnHeader';

import useSortableGrid from '@usas/ui-web/utils/UseSortableGrid';
import SGConstants from '@usas/ui-web/utils/SGConstants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const GridRow = ({ groupInvite, onGroupInviteClicked }) => (
  <tr>
    <td><a onClick={(e) => onGroupInviteClicked(e, groupInvite)}>
      {groupInvite.firstName || ''} {groupInvite.lastName || ''}
    </a></td>
    <td>{groupInvite.groupName || ''}</td>
    <td>{groupInvite.email || ''}</td>
    <td>{groupInvite.contactEmail || ''}</td>
    <td>{groupInvite.zoneOrgUnitCode || ''}</td>
    <td>{groupInvite.lscOrgUnitCode || ''}</td>
    <td>{groupInvite.clubOrgUnitCode || ''}</td>
    <td>{groupInvite.competitionGenderTypeCode || ''}</td>
  </tr>
);

const GroupSAAInviteGridLarge = ({ data, isLoading, onGroupInviteClicked }) => {
  const {
    sortableGridState,
    onColumnClicked
  } = useSortableGrid(data);

  return (
    <table className={[global.UsasTable, 'visible-lg visible-md'].join(' ')}>
      <thead>
        <tr>
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Name'} columnField={'lastName'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Group'} columnField={'groupName'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Athlete Email'} columnField={'email'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Contact Email'} columnField={'contactEmail'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Zone'} columnField={'zoneOrgUnitCode'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader style={{minWidth: '50px'}} sortableGridState={sortableGridState} columnLabel={'LSC'} columnField={'lscOrgUnitCode'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader style={{minWidth: '60px'}} sortableGridState={sortableGridState} columnLabel={'Club'} columnField={'clubOrgUnitCode'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader style={{minWidth: '170px'}} sortableGridState={sortableGridState} columnLabel={'Competition Category'} columnField={'competitionGenderTypeCode'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
        </tr>
      </thead>
      <tbody>
        {isLoading === true
          ? <tr><td colSpan="8">Loading...</td></tr>
          : sortableGridState.sortedGridData.length > 0
            ? sortableGridState.sortedGridData.map((groupInvite, i) => <GridRow key={i} groupInvite={groupInvite} onGroupInviteClicked={onGroupInviteClicked} />)
            : <tr><td colSpan="8">No Group Invites</td></tr>
        }
      </tbody>
    </table>
  );
};

export default GroupSAAInviteGridLarge;